<template>
    <div class="container-fluid">
        <div>
            <div class="form-group">
                <label for="client-phone">Вацап клиента</label>
                <base-input	
                    name="phone"
                    placeholder="Номер для сообщения вацап"
                    :mask="'phone'"
                    validate="phone"
                    v-model="phone"
                    :required=true
                    id="client-phone"
                    />
            </div>
            <div class="form-group">
                <label for="client-message">Сообщение</label>
                <textarea
                    id="client-message"
                    class="form-control"
                    v-model="message"
                    rows="4"
                ></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <button class="btn btn-simple btn-secondary" @click="$emit('close')">Закрыть</button>
            </div>
            <div class="col text-right">
                <button class="btn btn-simple btn-success" @click="sendMessage()">Отправить</button>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'RepeatLeadMessage',
    components:{
    },
    data(){
        return {
            phoneData:{
                contact_group:'messanger',
                contact_type:'WhatsApp',
                contact_value:this.phone,
            },
            phoneType:[{value:'wa',label:'Вацап'}],
        }
    },
    props:{
        id:Number,
        title:String,
        message: String,
        phone: String,
        row:{type:Object, default(){return{}}},
    },
    methods:{
        sendMessage:async function(){
            let result = await this.$GVO.Api.LEAD.whatsapp2client({
                flt:{
                    lead_id:this.row.id,
                    client_id:this.row.client_id
                },iData:{phone: this.phone, message: this.message}});
            this.$emit('close');
        }
    }
}
</script>